import { NotFoundView } from "@/views/common/notfound.view";
import { Route, Switch } from "wouter";
import { PhonebookView } from "./phonebook.view";

export function PhonebookRoutes() {
  return (
    <Switch>
      <Route path={"/"} component={PhonebookView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
